import { render, staticRenderFns } from "./text-overline2.vue?vue&type=template&id=2ff998c0&scoped=true&"
var script = {}
import style0 from "./text-overline2.vue?vue&type=style&index=0&id=2ff998c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff998c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff998c0')) {
      api.createRecord('2ff998c0', component.options)
    } else {
      api.reload('2ff998c0', component.options)
    }
    module.hot.accept("./text-overline2.vue?vue&type=template&id=2ff998c0&scoped=true&", function () {
      api.rerender('2ff998c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-overline2.vue"
export default component.exports